import React, { useEffect, useState } from 'react';
import { Drawer, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import CustomButton from "../buttons/CustomButton";
import styles from './CustomiseColumns.module.css';
import cross from './../../../assets/images/refresh-cw 1.svg';
import { useMsal } from "@azure/msal-react";

function ReasonForChange({ anchor, savedComment, earlierSavedComments = [], isDrawerOpen, saveCommentinResponseChange, cancelCommentinResponseChange }) {
    const { accounts } = useMsal();
    const activeAccount = accounts[0];
    const [comment, setComment] = useState('');
    const [savedOldComment, setSavedOldComment] = useState('');

    useEffect(() => {
        if (earlierSavedComments.length && earlierSavedComments.includes(savedComment?.['Comment For Reason'])) {
            setSavedOldComment(savedComment?.['Comment For Reason']);
        } else {
            setComment(savedComment?.['Comment For Reason']);
        }
    }, [savedComment, earlierSavedComments]);


    const saveComments = () => {
        saveCommentinResponseChange(savedOldComment || comment, isDrawerOpen.rowIndex, isDrawerOpen.IsAddNewCBU);
    }

    const selectOldComments = (event) => {
        setSavedOldComment(event.target.value);
    }

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    }


    return (
        <Drawer
            anchor={anchor}
            open={isDrawerOpen.isOpen}
        >
            <div className={styles.drawerContainer}>
                {/* heading */}
                <div className={styles.heading}>
                    <p>Reason for change</p>
                    <img src={cross} className={styles.closeIcon} onClick={cancelCommentinResponseChange} alt='Close drawer' />
                </div>
                {/* content */}
                <div className={styles.drawerContent}>
                    <div className={styles.addComment}>
                        <textarea maxLength="200" value={comment} placeholder="Enter the reason for change" onChange={handleCommentChange} />
                        <small>{comment && comment.length ? comment.length : 0}/200</small>
                    </div>
                    {Boolean(earlierSavedComments && earlierSavedComments.length) &&
                        <div className={styles.selectComments}>
                            <FormControl>
                                <FormLabel
                                    id="radio-buttons-group-label"
                                    className={styles.previousReasonsLabel}
                                >
                                    Previous reasons
                                </FormLabel>
                                <RadioGroup
                                    aria-labelledby="radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    sx={{
                                        '& .MuiFormControlLabel-root .MuiFormControlLabel-label': {
                                            fontWeight: '400',
                                            fontSize: '12px',
                                            color: 'dimgray',
                                        }
                                    }}
                                >
                                    {earlierSavedComments.length > 0 && earlierSavedComments.map((item) => (
                                        <FormControlLabel
                                            key={`Comment${item.id}`}
                                            checked={item.comment === savedOldComment}
                                            value={item.comment}
                                            className={styles.radioInputs}
                                            control={<Radio />}
                                            label={item.comment}
                                            onChange={selectOldComments}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>
                    }
                </div>
                {/* buttons */}
                <div className={styles.drawerBtns}>
                    <CustomButton label="Cancel" type="mm-save" onClick={cancelCommentinResponseChange} />
                    <CustomButton label={"Save"} type="mm-submit" onClick={saveComments} disabled={comment || savedOldComment ? false : true} />
                </div>
            </div>
        </Drawer>
    )
}

export default ReasonForChange;